'use es6';

export function v2gate(name) {
  return name;
}

export function gate(name) {
  // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
  return `g8:${name}`;
}
